export default [
    {
        path: 'exame-solicitado-status',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-exame-solicitado-status' */
            '@/views/exame-laboratorial/exame-solicitado-status/Index'
        ),
        redirect: 'exame-solicitado-status/index',
        children: [
            {
                name: 'exame-laboratorial-exame-solicitado-status-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-exame-solicitado-status' */
                    '@/views/exame-laboratorial/exame-solicitado-status/List.vue'
                ),
            },
        ],
    }
]